import { render } from "./FoodHandlerModal.vue?vue&type=template&id=2fc663f8"
import script from "./FoodHandlerModal.vue?vue&type=script&lang=js"
export * from "./FoodHandlerModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__